import React from "react";
import { LogUploadSourceType } from "types/api/aiRiskMgmt";

import { LogFileUpload } from "../GenericIntegration";

export default function GoogleWorkspaceFileUpload() {
  return (
    <LogFileUpload
      sourceType={LogUploadSourceType.GOOGLE_WORKSPACE}
      label="Google Workspace"
    />
  );
}
